export const RELEVANT_DOMAINS = [
  'CKLA',
  'CKLA Pilot',
  'Caminos',
  'ELA',
  'Science',
  'Math',
  'Slides Custom Created From Scratch',
  'Tutorial',
  'mCLASS',
  'Boost',
  'Elementary Literacy Program',
  'TX ELAR 6-8',
] as const;

export type RelevantDomains = (typeof RELEVANT_DOMAINS)[number];
